import * as qrCodeManageDetails from '../services/qrCodeManageDetails';

export default {
  namespace: 'qrCodeManageDetails',

  state: {
    searchFormData: null,
    tab: 0,
    tableList: null,
    total: 0,
    hasNext: false,
    groupList: null,
    qrParamsFormData: [{ title: '' }],
    refreshQrParamsFormData: 0,
  },

  effects: {
    //获取二维码的buffer
    *getQrCodeBuffer({ payload: { values }, callback }, { call }) {
      const response = yield call(qrCodeManageDetails.getQrCodeBuffer, values);
      callback && callback(response);
    },

    // 分页查询 二维码管理-列表
    *qrcodePage({ payload: { values }, callback }, { put, call }) {
      const response = yield call(qrCodeManageDetails.qrcodePage, values);
      yield put({
        type: 'save',
        payload: {
          hasNext: response?.data.hasNext,
          total: response?.data.total,
          tableList: response?.data?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // 删除二维码
    *deleteQrCode({ payload: { values }, callback }, { call }) {
      const response = yield call(qrCodeManageDetails.deleteQrCode, values);
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (props.pathname === '/system/qr_code_manage/details') {
          dispatch({
            type: 'save',
            payload: {
              groupList: null,
              qrParamsFormData: [{ title: '' }],
              defaultFormData: null,
              autoReplyList: null,
              refreshQrParamsFormData: 0,
            },
          });
        }
      });
    },
  },
};
